import { FilterAttribute } from '@/types/filterAttribute';
import { SearchItem } from '../../preferences/types';

export const OtherValues = ({
  currentState: { brands, countries, compositeCategories, specialties, platforms },
  omit,
}: {
  currentState: {
    brands?: SearchItem[];
    compositeCategories?: string[];
    specialties?: SearchItem[];
    platforms?: SearchItem[];
    countries: SearchItem[];
  };
  omit: FilterAttribute;
}) => {
  return (
    <>
      {omit !== 'platforms' &&
        platforms?.map(({ id }) => (
          <input type="hidden" name="platforms[]" value={id} key={`platformid-${id}`} />
        ))}
      {omit !== 'compositeCategories' &&
        compositeCategories?.map((id) => (
          <input type="hidden" name="categories[]" value={id} key={`category-${id}`} />
        ))}
      {omit !== 'specialties' &&
        specialties?.map(({ id }) => (
          <input type="hidden" name="specialties[]" value={id} key={`specialtyid-${id}`} />
        ))}
      {omit !== 'brands' &&
        brands?.map(({ id }) => (
          <input type="hidden" name="brands[]" value={id} key={`brandid-${id}`} />
        ))}
      {countries.map(({ id }) => (
        <input type="hidden" name="countries[]" value={id} key={`countryid-${id}`} />
      ))}
    </>
  );
};
